"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("antd/es/table/style/css");

var _table = _interopRequireDefault(require("antd/es/table"));

var _react = _interopRequireWildcard(require("react"));

var _moment = _interopRequireDefault(require("moment"));

var _Username = _interopRequireDefault(require("../username/Username"));

require("./editForm.scss");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const {
  Column
} = _table.default;
const tableStyle = {
  background: '#FFF'
};

const rowClassName = (record, index) => {
  return index % 2 === 0 ? 'tr-even-color' : 'tr-odd-color';
};

const typeFilters = [{
  text: 'Adverse Event',
  value: 'ADVERSE_EVENT'
}, {
  text: 'Early Termination',
  value: 'EARLY_TERMINATION'
}, {
  text: 'Protocol Deviation',
  value: 'PROTOCOL_DEVIATION'
}, {
  text: 'Social Harm',
  value: 'SOCIAL_HARM'
}];

class FormTable extends _react.Component {
  constructor() {
    super(...arguments);
    this.state = {
      viewForm: false,
      editing: false,
      currentForm: undefined
    };

    this.handleViewForm = id => {
      if (this.props.forms) {
        this.setState({
          viewForm: true,
          currentForm: this.props.forms.find(f => f.id === id)
        });
      }
    };

    this.handleEditForm = id => {
      if (this.props.forms) {
        this.setState({
          viewForm: true,
          editing: true,
          currentForm: this.props.forms.find(f => f.id === id)
        });
      }
    };

    this.renderFormModal = (form, visible, type) => {
      const {
        editing
      } = this.state;
      if (!visible) return /*#__PURE__*/_react.default.createElement("div", null);

      switch (type) {
        default:
          return /*#__PURE__*/_react.default.createElement("div", null);
      }
    };

    this.handleClose = () => {
      this.setState({
        viewForm: false,
        editing: false,
        currentForm: null
      });
    };

    this.renderFormLink = id => {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "form-action-container"
      }, /*#__PURE__*/_react.default.createElement("a", {
        title: "View",
        className: "form-action",
        onClick: e => this.handleViewForm(id)
      }, /*#__PURE__*/_react.default.createElement("i", {
        className: "far fa-eye fa-lg"
      })), ",", /*#__PURE__*/_react.default.createElement("a", {
        title: "Edit",
        className: "form-action",
        onClick: e => {
          e.stopPropagation();
          this.handleEditForm(id);
        }
      }, /*#__PURE__*/_react.default.createElement("i", {
        className: "far fa-edit fa-lg"
      })));
    };

    this.sorterCreateDate = (a, b) => (0, _moment.default)(a.createDate).unix() - (0, _moment.default)(b.createDate).unix();

    this.renderParticipant = id => {
      if (id) {
        return /*#__PURE__*/_react.default.createElement(_Username.default, {
          participantId: id
        });
      }

      return 'N/a';
    };

    this.renderBoolean = bool => {
      return bool ? 'True' : 'False';
    };

    this.onFilterResolved = (value, record) => {
      if (value) {
        return record.isResolved === parseInt(value);
      }

      return false;
    };

    this.handleRowClick = record => {
      if (record && record.id && this.props.forms) {
        this.setState({
          viewForm: true,
          currentForm: this.props.forms.find(f => f.id === record.id)
        });
      }
    };
  }

  render() {
    const {
      forms: filteredForms
    } = this.props;
    const {
      currentForm,
      viewForm
    } = this.state;
    const resolvedFilters = [{
      text: 'Resolved',
      value: '1'
    }, {
      text: 'Open',
      value: '0'
    }];
    return /*#__PURE__*/_react.default.createElement("div", null, currentForm ? this.renderFormModal(currentForm, viewForm, currentForm.formType) : /*#__PURE__*/_react.default.createElement("div", null), /*#__PURE__*/_react.default.createElement(_table.default, {
      pagination: false,
      dataSource: filteredForms,
      rowKey: "id",
      rowClassName: rowClassName,
      style: tableStyle,
      onRow: (record, rowIndex) => {
        return {
          onClick: event => this.handleRowClick(record),
          onDoubleClick: event => {},
          onContextMenu: event => {},
          onMouseEnter: event => {},
          onMouseLeave: event => {} // mouse leave row

        };
      }
    }, /*#__PURE__*/_react.default.createElement(Column, {
      title: "Username",
      dataIndex: "participantId",
      key: "username",
      render: value => /*#__PURE__*/_react.default.createElement(_Username.default, {
        participantId: value
      }),
      sorter: (a, b) => a.participantId && b.participantId ? a.participantId - b.participantId : 0
    }), /*#__PURE__*/_react.default.createElement(Column, {
      title: "Form Type",
      dataIndex: "formType",
      key: "formType",
      render: type => type.split('_').map(s => s.charAt(0) + s.substring(1).toLowerCase()).join(' '),
      filters: typeFilters,
      onFilter: (value, record) => record.formType === value
    }), /*#__PURE__*/_react.default.createElement(Column, {
      title: "Date",
      dataIndex: "createDate",
      key: "createDate",
      defaultSortOrder: "descend",
      sorter: this.sorterCreateDate,
      render: date => (0, _moment.default)(date).calendar()
    }), /*#__PURE__*/_react.default.createElement(Column, {
      title: "Admin ID",
      dataIndex: "adminId",
      key: "adminId"
    }), /*#__PURE__*/_react.default.createElement(Column, {
      title: "Resolved?",
      dataIndex: "isResolved",
      key: "isResolved",
      render: this.renderBoolean,
      filters: resolvedFilters,
      onFilter: this.onFilterResolved
    }), /*#__PURE__*/_react.default.createElement(Column, {
      title: "View",
      dataIndex: "id",
      key: "id",
      render: (text, row, id) => this.renderFormLink(id)
    })));
  }

}

var _default = FormTable;
exports.default = _default;